import firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/database';

async function upload(files, path, onPercentage) {
  for (let i = 0; i < files.length; i++) {
    const file = files[i];

    if(!!file.url) continue;
    
    const url = await uploadFile(file, path, snapshot => {
      const { bytesTransferred, totalBytes } = snapshot;

      const filePercentage = (bytesTransferred / totalBytes) * 100;

      const perFilePercentage = (100 / files.length);
      const percentage =
            (perFilePercentage * i) +
            (perFilePercentage * (filePercentage/100));

      if(onPercentage) onPercentage(Math.round(percentage));
    });

    file.url = url;
  }

  if(onPercentage) onPercentage(null);

  return files.map(file => ({
    name: file.name,
    size: file.size,
    type: file.type,
    url: file.url
  }))
}

function uploadFile(file, path, onSnapshot) {
  return new Promise((resolve, reject) => {
    const storage = firebase.storage().ref(),
        child = storage.child(path + file.name),
        task = child.put(file);

    task.on('state_changed', onSnapshot, reject, async () => {
      const url = await task.snapshot.ref.getDownloadURL();

      resolve(url);
    });
  });
}

export default {
  upload
}